// extracted by mini-css-extract-plugin
export default {"wrapper":"feed-page_wrapper__5H12p","heading":"feed-page_heading__QeeAp","container":"feed-page_container__vpUWM"};